<template>
  <div class="page_content create-section">

		<div class="page_heading">
			<div class="col-5 module_heading">
				<span class="module_icon icon-mentor"></span>
	            <span class="module_title">Create User</span>
			</div>

			<div class="col-7 btn_container">
				<button v-on:click="validateUser" class="btn btn-primary" aria-label="save">save</button>
				<button v-on:click="cancel" class="btn btn-primary" aria-label="cancel">cancel</button>
    		</div>
    	</div>
		<div class="content-section">
			<div class="row content-row">
				<div class="col-6 row">
					<div class="col-4 form-label" id="userEmail">User Email <sup>*</sup></div>
					<div class="col-7"><input v-model="user.eMail" @input="forceTrim($event, user, 'eMail')" aria-labelledby="userEmail" placeholder="User Email" required></div>
				</div>
				<div class="col-6 row">
					<div class="col-4 form-label" id="password">Password <sup>*</sup></div>
					<div class="col-7"><input v-model="user.password" aria-labelledby="password" placeholder="Password" required type="password"></div>
				</div>
			</div>

			<div class="row content-row">
				<div class="col-6 row">
					<div class="col-4 form-label" id="firstName">First Name <sup>*</sup></div>
					<div class="col-7"><input v-model="user.firstName" aria-labelledby="firstName" placeholder="First Name" required></div>

				</div>
				<div class="col-6 row">
					<div class="col-4 form-label" id="middleName">Middle Name</div>
					<div class="col-7"><input v-model="user.middleName" aria-labelledby="middleName" placeholder="Middle Name"></div>
				</div>
			</div>

			<div class="row content-row">
				<div class="col-6 row">
					<div class="col-4 form-label" id="lastName">Last Name <sup>*</sup></div>
					<div class="col-7"><input v-model="user.lastName" aria-labelledby="lastName" placeholder="Last Name" required></div>
				</div>
				<div class="col-6 row">
					<div class="col-4 form-label" id="userRole">Role <sup>*</sup></div>
					<div class="col-7">
						<select v-model="role" aria-labelledby="userRole">
							<option v-for="option in userRoles" v-bind:value="option">
							  {{ option }}
							</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row content-row">
				<div class="col-6 row">
					<div class="col-4 form-label" id="country">Country</div>
					<div class="col-7"><input v-model="user.country" aria-labelledby="country" placeholder="Country"></div>
				</div>
				<div class="col-6 row">
					<div class="col-4 form-label" id="state">State</div>
					<div class="col-7"><input v-model="user.city" aria-labelledby="state" placeholder="State"></div>
				</div>
			</div>

			 <div class="row content-row">
				<div class="col-6 row">
					<div class="col-4 form-label" id="timeZone">Time Zone</div>
					<div class="col-7">
						<select v-model="user.timeZone" aria-labelledby="timeZone">
							<option v-for="option in timeZones" v-bind:value="option">
							  {{ option }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-6 row">
					<div class="col-4 form-label" id="language">Language</div>
					<div class="col-7">
						<select v-model="language" aria-labelledby="language">
							<option v-for="option in languages" v-bind:value="option">
							  {{ option }}
							</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row content-row">
				<div class="col-6 row">
          <div class="col-4 form-label" id="externalId">External Id</div>
          <div class="col-7"><input v-model="user.externalId" aria-labelledby="externalId" placeholder="External Id"></div>
        </div>
        <div class="col-6 row">
					<div class="col-4 form-label" id="organization">Organization</div>
					<div class="col-7"><input v-model="user.organization" aria-labelledby="organization" placeholder="Organization"></div>
				</div>
			</div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="description">Description</div>
          <div class="col-7"><textarea v-model="user.description" aria-labelledby="description" placeholder="Description"></textarea></div>
        </div>
      </div>

      <div class="row content-row" v-if="isAdvisor">
        <div class="col-6 row">
          <div class="col-4 form-label" id="description"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="defaultAdvisor" v-model="user.defaultAdvisor"> <span id="defaultAdvisor" class="select-row">Check to make default advisor</span></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="description"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="customAdvisor" v-model="user.customAdvisor"> <span id="customAdvisor" class="select-row">Check to make Custom Advisor</span></div>
        </div>
      </div>

			<div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="doNotSendWelcomeEmail" v-model="user.doNotSendWelcomeEmail"> <span id="doNotSendWelcomeEmail" class="select-row">Do not send welcome email</span></div>
        </div>
				<div class="col-6 row">
					<div class="col-4 form-label"></div>
					<div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="createPerson" v-model="user.createPerson"> <span id="createPerson" class="select-row">Create person profile for this user</span></div>
				</div>
			</div>
      <div class="row content-row" >
        <div class="col-6 row" v-if="isAdmin">
          <div class="col-4 form-label" id="description"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="customAdmin" v-model="user.customAdmin"> <span id="customAdmin" class="select-row">Check to make Custom Admin</span></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="description"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="createChildInsUser" v-model="user.createChildInsUser"> <span id="createChildInsUser" class="select-row">Create User in Child Institutions</span></div>
        </div>

      </div>
      <div class="row content-row" >
        <div class="col-6 row" v-if="isSuperAdmin">
          <div class="col-4 form-label" id="description"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" title="Only Superadmin can set thie permission" :disabled="!isSuperAdmin" aria-labelledby="aiAdmin" v-model="user.aiAdmin"> <span title="Only Superadmin can set thie permission" id="aiAdmin" class="select-row">Check to make AI Admin</span></div>
        </div>
      </div>

      <div class="row content-row" v-if="isCustomAdmin">
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="canManageWebsiteWidget" v-model="user.customPermission.canManageWebsiteWidget"> <span id="canManageWebsiteWidget" class="select-row">Can Manage Website Widgets</span></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="canManageLandingPages" v-model="user.customPermission.canManageLandingPages"> <span id="canManageLandingPages" class="select-row">Can Manage Landing Pages</span></div>
        </div>
      </div>
      <div class="row content-row" v-if="isCustomAdmin">
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="canManageEmailCampaign" v-model="user.customPermission.canManageEmailCampaign"> <span id="canManageEmailCampaign" class="select-row">Can Manage Email Campaigns</span></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="canManageMarketingHighlights" v-model="user.customPermission.canManageMarketingHighlights"> <span id="canManageMarketingHighlights" class="select-row">Can Manage Marketing Highlights</span></div>
        </div>
      </div>
      <div class="row content-row" v-if="isCustomAdmin">
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="canManageECommerce" v-model="user.customPermission.canManageECommerce"> <span id="canManageECommerce" class="select-row">Can Manage E-Commerce</span></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="canAccessInstitutionReports" v-model="user.customPermission.canAccessInstitutionReports"> <span id="canAccessInstitutionReports" class="select-row">Can Access Reports</span></div>
        </div>
      </div>

      <div class="row content-row" v-if="isCustomAdmin">
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="supervisorRole" v-model="user.customPermission.supervisorRole"> <span id="supervisorRole" class="select-row">Supervisor Role</span></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label"></div>
          <div class="col-7"><input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="superSupervisorRole" v-model="user.customPermission.superSupervisorRole"> <span id="superSupervisorRole" class="select-row">SuperSupervisor Role</span></div>
        </div>
      </div>

		</div>

		<div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'createUser',
    props: ['parentSpaceId'],
    data () {
      return {
        userRoles: ['Instructor & Admin', 'Employer Admin', 'Instructor', 'Observer', 'Curator', 'Advisor', 'Student', 'Coach', 'Recruiter', 'Prospective Student', 'Admitted Student', 'Widget Admin'],
        languages: ['English', 'Hindi', 'French', 'German', 'Spanish'],
        timeZones: ['(-12:00) Eniwelok, Kwajalein', '(-11:00) Midway Island, Samoa', '(-10:30) Cook Islands', '(-10:00) Hawaii; Western Aleutian Islands=was Alaska/Hawaii timezone', '(-09:30) Marquesas Islands', '(-09:00) Alaska; Eastern Aleutian Islands=was Yukon timezone', '(-08:30) Pitcairn Island', '(-08:00) Pacific Time (US & Canada); Yukon; Tijuana',
          '(-07:00) Mountain Time (US & Canada)', '(-06:00) Central Time (US & Canada); Mexico City, Tegucigalpa', '(-05:00) Eastern Time (US & Canada); Bogota; Lima; Quito', '(-04:30) Caracas', '(-04:00) Atlantic Time (Canada); Caracas, La Paz; Santiago', '(-03:45) Guyana, South America', '(-03:30) Newfoundland; Suriname, South America', '(-03:00) Greenland; Brasilia; Buernos Aires; Puerto Rico', '(-02:00) Mid-Atlantic', '(-01:00) Azores, Cape Verde Is.', '(00:00) Greenwich Mean Time',
          '(+01:00) Amsterdam; Berlin; Bern; Rome; Stockholm; Vienna', '(+02:00) Athens; Istanbul; Minsk; Jerusalem', '(+03:00) Baghdad; Kuwait; Moscow', '(+03:30) Tehran, Iran', '(+04:00) Abu Dhabi; Muscat', '(+04:30) Kabul, Afghanistan', '(+05:00) Ekaterinburg', '(+05:30) India; Bombay; Calcutta; New Delhi; Sri Lanka',
          '(+05:45) Kathmandu, Nepal', '(+06:00) Astana; Dhaka', '(+06:30) Cocos Islands; Yangon; Myanmar', '(+07:00) Bangkok; Hanoi', '(+08:00) Perth; Singapore; China', '(+08:45) South Australia', '(+09:00) Osaka; Tokyo; Seoul', '(+09:30) Northern Australia', '(+10:00) Brisbane; Canberra; Sydney; Guam',
          '(+11:00) Magadan; Solomon Is.; New Caledonia', '(+11:30) New Zealand?; Norfold Island, Australia', '(+12:00) Auckland; Wellington; Fiji; Marshall Is.; Tuvalu', '(+12:45) Chatham Island, New Zealand', '(+13:00) Nukulalofa; Phoenix Islands=1 hour EAST of the dateline',
          '(+14:00) Line Islands; Christmas Islands=2 hours EAST of the dateline', ''],
        user: {
          city: null,
          country: null,
          createPerson: true,
          externalId: null,
          organization: null,
          description: null,
          eMail: '',
          firstName: '',
          language: null,
          lastName: '',
          middleName: null,
          password: '',
          personType: '',
          roles: [],
          timeZone: null,
          userProfile: {courses: [], areaOfInterest: [], experience: '', bio: ''},
          customPermission : {canManageWebsiteWidget:false,canManageLandingPages:false,canManageEmailCampaign:false,canManageMarketingHighlights:false, canManageECommerce:false,canAccessInstitutionReports:false, supervisorRole:false, superSupervisorRole:false},
          doNotSendWelcomeEmail: true
        },
        role: 'Instructor & Admin'
      }
    },

    mounted () {
    },

    computed: {
      currentInstitutionId () {
        let userObj = JSON.parse(localStorage.getItem('userobj'))
        let institutionId = this.parentSpaceId
        return institutionId || userObj.institutionId
      },

      loggedInUserId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.uuid
      },
      isAdmin () {
        if (this.role.toLowerCase() === 'instructor & admin') {
          return true
        }
        return false
      },
      isCustomAdmin () {
        if (this.role.toLowerCase() === 'instructor & admin' && this.user.customAdmin) {
          return true
        }
        return false
      },
      isSuperAdmin () {
        let userObject = JSON.parse(localStorage.getItem('userobj'))
        let permission = userObject.permission || this.permission
        let cond = permission.name === 'SUPERADMIN_PERMISSION'
 //       alert(cond)
        return cond
      },
      isAdvisor () {
        if (this.role.toLowerCase() === 'advisor') {
          return true
        }
        return false
      }
    },

    methods: {
      ...mapActions([
        'loadCreateUser'
      ]),

      forceTrim (e, o, prop) {
        const start = e.target.selectionStart
        e.target.value = e.target.value.trim()
        this.$set(o, prop, e.target.value)
        e.target.setSelectionRange(start, start)
      },

      cancel () {
        this.$router.push({ name: 'listUsers', params: { parentSpaceId: this.currentInstitutionId } })
      },

      createUser () {
        this.showLoader()
        this.user.roles = this.processRoles()
        this.loadCreateUser({parentSpaceId: this.currentInstitutionId, user: this.user}).then(res => {
          if (res) {
            if (res === 'duplicate_email_value') {
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Please try again. This email "' + this.user.eMail + '" is already taken.'
              })
            } else {
              this.$router.push({ name: 'listUsers', params: { parentSpaceId: this.currentInstitutionId } })
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'Successfully created user.'
              })
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Please try again. Note that this email "' + this.user.eMail + '" might already be taken.'
            })
          }
          this.hideLoader()
        })
      },
      processRoles () {
        var roles = [{'role': this.role}]
        return roles
      },
      validateUser () {
        if (this.role.length > 0 && this.user.firstName.length > 0 && this.user.lastName.length > 0 && this.user.eMail.length > 0 && this.user.password.length >= 6) {
          this.createUser()
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Email, Password, First Name, Last Name and Role are required. Password must be at least 6 characters'
          })
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/user/components/CreateUser.vue